import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import AnswerPage from "./AnswerPage";
import Dashboard from "./Dashboard";

import Login from "./Login";
import Student from "./Student";
import StudentSubmission from "./StudentSubmission";

export default function Main(){
    return(
        <Router>
            <Switch>
                <Route exact path="/" component={Login} />
                <Route path = "/studentSubmission" component={StudentSubmission} />
                <Route path="/dashboard" component={Dashboard} />
                <Route path="/student/:roomID" component={Student} />
                <Route path="/answers" component ={AnswerPage} />
            </Switch>
        </Router>
    )
}